import React, {useState, useEffect} from 'react'
/* import shareFacebook from 'share-facebook' */
/* import { FacebookProvider, ShareButton } from 'react-facebook'; */
import Button from 'react-bootstrap/Button'
import { Helmet, HelmetProvider } from 'react-helmet-async'
/* import { Root, Routes, Head } from 'react-static' */
import configData from '../../temp/config'
import Popup from '../RecipeDetailCommon/Popup/Popupformbootstrap'
import { withTranslation } from 'react-i18next'


const defaultstarticon = 'fa fa-star-o'

function WildcardData(props) {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [iconName, setIconname] = useState(defaultstarticon)

  const [apidata, setApidata] = useState({
      age:'',
      body:'',
      category:'',
      duration:'',
      image:'',
      keywords:'',
      summary:'',
      thumbnail:'',
      title:'',
      tooltitle:'',
      keywordlink:'',
      brandlogo:'',
      recaptchaseckey:'',
      recaptchasitekey:'',
      emailsubject:'',
      itemid:''
  })

  useEffect(() => { 
      setApidata({
          age:props.fields.age ? props.fields.age.fields.labelName.value : '',
          body:props.fields.body ? props.fields.body : '',
          category:props.fields.category ? props.fields.category.fields.labelName.value:'',
          duration:props.fields.duration ? props.fields.duration.fields.labelName.value : '',
          image:props.fields.image.value ? props.fields.image.value : '',
          keywords:props.fields.keywords.value ? props.fields.keywords.value.split(',') :'',
          summary:props.fields.summary ? props.fields.summary : '',
          thumbnail:props.fields.image.value ? props.fields.image.value : '',
          title:props.fields.title ? props.fields.title : '',
          tooltitle:document.getElementById('tooltitle').value ? document.getElementById('tooltitle').value : '',
          keywordlink:document.getElementById('keywordlink').value ? document.getElementById('keywordlink').value : '',
          brandlogo: document.getElementById('brandlogo').value ? document.getElementById('brandlogo').value : '',
          toolicon: document.getElementById('toollogo').value ? document.getElementById('toollogo').value : '',
          recaptchaseckey: document.getElementById('recaptchaseckey').value ? document.getElementById('recaptchasitekey').value : '',
          recaptchasitekey:  document.getElementById('recaptchasitekey').value ? document.getElementById('recaptchasitekey').value : '',
          emailsubject:  document.getElementById('emailsubject').value 
                          ? document.getElementById('emailsubject').value.replace('{RecipeName}',props.fields.title.value)
                          : '',
          itemid:props.fields.itemId ? props.fields.itemId : ''
      })
      //let assignedcookie = document.cookie.split(';')
      //console.log(assignedcookie.map(item => item.split('cname=')[1]))      
  },[])

  var loadScript = function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
    fjs.parentNode.insertBefore(js, fjs);
  }
  loadScript(document, 'script', 'facebook-jssdk')

  function fbshare(url, title) {
      let u = url;
      let t = title;
      window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t), 'sharer', 'toolbar=0,status=0,left=200,top=150,width=626,height=436');
  } 

  const { t } = props;

  function setRCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    setIconname('fa fa-star')
  }

  return(
    <>
    <div className="newheader">  
      <img src={`${configData.sitecoreApiHost}${apidata.brandlogo && apidata.brandlogo}`} />
    </div>
    <div id="fb-root"></div>
    <div className="tool-header tool-header-recipe header-detail">
      <img src={`${configData.sitecoreApiHost}${apidata.toolicon && apidata.toolicon}`} />        
      <h1 className="redText">{apidata.tooltitle}</h1>
    </div>
    <div className="tool-mobile-header tool-mobile-header-recipe">
        {/* <a  href={`${apidata.keywordlink.toLowerCase()}`} className="closelink">X</a>  */}               
        <div className="blk blk-btn">
        <a type="button" href={`${apidata.keywordlink.toLowerCase()}`} id="name-search-button" className="btn btn-p">{t('RecipeFinder_SearchAnotherRecipe')}</a> 
        </div>
    </div>    
    <div className="UtilityWrap-brf UtilityWrap-brf-detail">
      <HelmetProvider>
          <Helmet>
              <title>{apidata.title.value}</title>
              <meta property="og::site_name" content="website" />
              <meta property="og:url" content="https://pwa-kimclark-com-dev-ncus.azurewebsites.net/recipe-finder/tofu-carrot-soup" />
              <meta property="og:type" content="website" />              
              <meta property="og:title" content="Huggies" />
              <meta property="og:description" content="(Huggies) - Làm sao để bé phát triển toàn diện cả thể chất lẫn trí tuệ? Huggies sẽ cung cấp đến bạn tất cả các hoạt động và trò chơi giành cho bé từ 0 - 3 tuổi." />              
              <meta property="og:image" content={`${configData.sitecoreApiHost}${apidata.thumbnail.src && apidata.thumbnail.src}`} />
          </Helmet>
      </HelmetProvider>
      {/* <Head>
        <meta property="og:title" content="Site Title" />
        <meta property="og:url" content="http://some-react-static-website.com" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="React Static Website" />
        <meta property="og:image" content="http://some-react-static-website/img/OG_thumb.jpg" />
      </Head> */}      
      <div className="detailblk">
        <h2>{apidata.title.value}</h2>  
        <div className="sharelinks">
          <div className="linkblk">
              <div className="favoriteblk">
                <Button variant="link"
                  onClick={() => setRCookie('cname',apidata.title.value,window.location.href)}>
                  <i className={iconName} aria-hidden="true"></i>
                  {t('RecipeFinder_Favorite')}
                </Button>
              </div>
              <div className="psharelinks">
              {/* <FacebookProvider appId="645929019346332">
                <ShareButton href="https://pwa-kimclark-com-dev-ncus.azurewebsites.net/recipe-finder/tofu-carrot-soup">
                  Share
                </ShareButton>
              </FacebookProvider> */}
                  {/* Your FB Share & Like button code 
                  <div className="fb-share-button" 
                      data-href='https://pwa-kimclark-com-dev-ncus.azurewebsites.net/recipe-finder/tofu-carrot-soup' 
                      data-width=""
                      //data-layout="button" 
                      //data-action="like" 
                      data-size="small"  
                      data-share="true">                        
                  </div>*/}

                  {/* <a target="_blank" href={shareFacebook({ redirect_uri:'https://pwa-kimclark-com-dev-ncus.azurewebsites.net', href:'https://pwa-kimclark-com-dev-ncus.azurewebsites.net/recipe-finder/tofu-carrot-soup', app_id: '223716281445085' })}>Share on Facebook</a> */}

                  {/* <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=small&width=96&height=20&appId=223716281445085" width="96" height="20" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe> */}
                  <Button 
                    variant="btn btn-link btn-link-fb" 
                    onClick={() => fbshare(window.location.href,apidata.title.value)}
                  >
                      {t('Common_Share')}
                      <i className="fa fa-facebook-square" aria-hidden="true"></i>
                  </Button>                        
                  <Button variant="link btn-link-mail" onClick={handleShow}>                    
                    {t('Common_Email')}
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </Button>                  
              </div>
          </div>
          <div className="hintblk">
            <p>{t('RecipeFinder_Time')} <span>{apidata.duration && apidata.duration}</span></p>
            <p>{t('RecipeFinder_Age')} <span>{apidata.age && apidata.age}</span></p>              
          </div>
        </div>
        { 
            show ?
                <Popup
                    show={show}
                    text='Click "Close Button" to hide popup'
                    handleClose={handleClose}
                    recaptchaseckey={apidata.recaptchaseckey}
                    recaptchasitekey={apidata.recaptchasitekey}
                    emailsubject={apidata.emailsubject}
                    itemid={apidata.itemid}
                />
            : null
        }
      <div className="recipeimgblk">
          <img src={`${configData.sitecoreApiHost}${apidata.thumbnail.src}`} />
      </div>
      <div className="recipedesc">
          <div
            className="bodycopy"
            dangerouslySetInnerHTML={{ __html: apidata.body.value }}
          />
      </div>
    </div>
      <div className="keywordblk">
        <p>
            {t('RecipeFinder_Keyword')}
            {
                apidata.keywords && apidata.keywords.map((keywords, index) => {
                    return <a href={`${apidata.keywordlink.toLowerCase()}?keyword=${keywords.trim().toLowerCase()}`} key={index}>{keywords.trim()}{apidata.keywords.length !== index+1 && ',' }</a>
                })
            }
        </p>
      </div>
      <div className="blk blk-btn blk-btn-backtosearch">
        <a type="button" href={`${apidata.keywordlink.toLowerCase()}`} id="name-search-button" className="btn btn-p">{t('RecipeFinder_SearchAnotherRecipe')}</a> 
      </div>
    </div>
    <div className="newfooter">
      <span>{t('Common_FooterText')}</span>
    </div>
    </>
  )

}

export default withTranslation()(WildcardData);
